import React, { Component } from 'react';
import {Icon, Menu, MenuItem, Popover, PopoverInteractionKind, Position} from "@blueprintjs/core";
import Modal from '@atlaskit/modal-dialog';
import { connect } from 'react-redux';
import {Map, List} from "immutable";

// Components
import VirtualizedTable from "../../../components/common/virtualized-table";
import AdjustStockDialog from "../../../components/dialogs/AdjustStockDialog";

// Actions
import {getStockList} from "../../../actions/stock";

class ProductStock extends Component {
    constructor(props) {
        super(props);

        this.state = {
            canSubmit: false,
            onCreateClick: false,
            modalIsOpen: false,
            modalType: null,
            stock: Map({})
        }
    }

    componentDidMount() {
        this.props.getStockList({
            filters: {
                product: this.props.productId
            },
            projection: 'warehouse real_amount available_amount total_amount security_stock',
            populateRefs: [{
                field: 'warehouse',
                projection: 'name'
            }]
        });
    }

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.state.canSubmit !== nextState.canSubmit ||
            this.state.modalIsOpen !== nextState.modalIsOpen ||
            this.props !== nextProps ||
            this.state.onCreateClick !== nextState.onCreateClick
        )
    }

    onCanSubmit = (canSubmit) => {
        this.setState({
            canSubmit
        });
    };

    // Modal Handlers
    openModal = (modalType) => {
        this.setState({
            modalType,
            modalIsOpen: true
        });
    };
    closeModal = () => {

        this.setState({
            modalType: null,
            modalIsOpen: false,
            canSubmit: false,
            onCreateClick: false
        })
    };

    render() {
        const { canSubmit, modalIsOpen, modalType, stock } = this.state;
        const { stockList } = this.props;

        // Stock Table
        let tableData = stockList;
        let tableSettings = {
            sortable: false,
            filterable: false,
            defaultSortFields: [],
            defaultSortDirections: ['asc'],
            height: tableData.size < 17 ? tableData.size * 40 : 680,
            rowHeight: 40,
            strippedRows: false
        };
        let tableColumns = {
            name: {
                title: 'Almacén',
                columnType: 'text',
                dataField: 'warehouse',
                width: 200,
                style: {},
                sortable: false,
                filterable: true
            },
            real_amount: {
                title: "Stock real",
                columnType: 'text',
                dataField: 'real_amount',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true
            },
            available_amount: {
                title: "Stock disponible",
                columnType: 'text',
                dataField: 'available_amount',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true
            },
            total_amount: {
                title: "Stock total",
                columnType: 'text',
                dataField: 'total_amount',
                width: 100,
                style: {textAlign: 'right'},
                sortable: true,
                filterable: true
            },
            security_stock: {
                title: "Stock de seguridad",
                columnType: 'text',
                dataField: 'security_stock',
                width: 100,
                style: {textAlign: 'right'},
                sortable: false,
                filterable: true
            },
            actions: {
                title: '',
                columnType: 'function',
                dataField: '_id',
                width: 30,
                style: { alignItems: 'center', maxWidth: 30 },
                sortable: false,
                filterable: false,
                nodeContent: (stockId) => {
                    const index = stockList.findIndex(stock => stock.get('_id') === stockId);
                    const stock = stockList.get(index);
                    const popoverContent = (
                        <Menu>
                            <MenuItem icon="eye-open" text="Ajustar stock" onClick={ () => {
                                this.setState({ stock }, () => this.openModal('adjustStockDialog'))
                            }} />
                        </Menu>
                    );

                    return (
                        <div>
                            <Popover
                                content={popoverContent}
                                interactionKind={PopoverInteractionKind.CLICK}
                                position={Position.LEFT_BOTTOM}
                            >
                                <Icon
                                    className="icon-custom"
                                    title={false}
                                    icon={'more'}
                                    iconSize={18}
                                    color="#183650"
                                />
                            </Popover>
                        </div>
                    );
                }
            }
        };

        // Modal Area
        let modal = null;

        if (modalIsOpen) {
            switch (modalType) {
                case 'adjustStockDialog':
                    modal = {
                        width: 'medium',
                        title: 'Ajustar Stock',
                        body: (
                            <AdjustStockDialog
                                stock={stock}
                                onCanSubmit={this.onCanSubmit}
                                onCreateClick={this.state.onCreateClick}
                                onCloseModal={this.closeModal}
                            />
                        ),
                        footer: (
                            <div className="modal-footer">
                                <button
                                    key="cancel"
                                    type="button"
                                    className="btn btn-cancel"
                                    label={'Cancelar'}
                                    style={{
                                        color: 'gray',
                                        marginRight: 15
                                    }}
                                    onClick={this.closeModal}
                                >
                                    {'Cancelar'}
                                </button>
                                <button
                                    key="accept"
                                    type="button"
                                    className="btn btn-primary"
                                    disabled={!canSubmit}
                                    onClick={ () => this.setState({ onCreateClick: true }) }
                                >
                                    {'Guardar'}
                                </button>
                            </div>
                        )
                    };
                    break;
                default:
                    modal = {
                        title: '',
                        body: null,
                        footer: null
                    };
                    break;
            }
        }

        return (
            <div className="panel-body">
                <VirtualizedTable
                    tableSettings={tableSettings}
                    tableColumns={tableColumns}
                    tableData={tableData}
                />
                { modalIsOpen && (
                    <Modal
                        width={modal.width}
                        heading={modal.title}
                        footer={() => modal.footer}
                        autoFocus={false}
                        onClose={this.closeModal}
                    >
                        {modal.body}
                    </Modal>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    // Reducers
    const stockReducer = state.stock;

    // Stock
    const stockList = stockReducer.get('payload') || List([]);

    return {
        stockList
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getStockList: (query) => dispatch(getStockList(query))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductStock);


// WEBPACK FOOTER //
// ./src/containers/configuration/products/ProductStock.js